import React from 'react';
import Verification from '../components/verification';

class VerificationPage extends React.Component{
	render(){
		return (
			<div>
				<Verification type={this.props.match.params.param}/>
			</div>
		)
	}
}

export default VerificationPage;


// WEBPACK FOOTER //
// ./src/containers/verification-page.js